module.exports = __webpack_public_path__ + "img/ggcdw-banner-pic.10bc9eda.png";